import { render } from "./addProductView.vue?vue&type=template&id=27020e3c&scoped=true"
import script from "./addProductView.vue?vue&type=script&lang=js"
export * from "./addProductView.vue?vue&type=script&lang=js"

import "./addProductView.vue?vue&type=style&index=0&id=27020e3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27020e3c"]])

export default __exports__